export const DEFAULT_TITLE = 'Dados Abertos'



// WEBPACK FOOTER //
// ./src/router/const.js